import React from 'react';
import Reflux from 'reflux';
import HeaderStore from '../../../stores/header';
import headerActions from '../../../actions/header';
import translate from '../../../utils/translate';

export default  class SlidingPanel extends Reflux.Component {

  constructor (props) {
    super(props);
    this.state = {
      ofMin: 0
    };

    this.mapStoreToStateKey(HeaderStore, 'headerStoreImported');
    this._handleDocumentClick = this._handleDocumentClick.bind(this);
  }

  mapStoreToStateKey = (store, key) => {
    this.mapStoreToState(store, changes => {
      this.setState(currentState => ({ [key]: {...currentState[key], ...changes} }));
    });
  };

  componentDidMount () {
    document.addEventListener('click', this._handleDocumentClick, false);
  }

  componentWillUnmount () {
    document.removeEventListener('click', this._handleDocumentClick, false);
  }

  _handleDocumentClick (e) {
    if (e.target.id === 'overlay' && this.props.isDesktop) {
      headerActions.toggleSlidingPanel();
    }
  }

  render () {
    const isOpen = this.state.headerStoreImported.isActiveSlidingPanel;
    const locationText = translate('headerModule', 'LOCATION');
    const menuStatus = isOpen ? 'isopen' : '';
    const menu = isOpen ? 'overlay-active' : 'overlay-inactive';
    const offsetObj = menuStatus !== 'isopen' ? {left: '-200%'} : {left: 0};
    return (
      <div>
        <div ref="root">
          <div style={offsetObj} className={menuStatus} id="slidingPanel-menu">
            <div className="slidingPanel-content">
              <span className="slidingPanel-closeBtn" onClick={headerActions.toggleSlidingPanel} />
              <span className="slidingPanel-heading">{locationText}</span>
            </div>
            <div className="slidingPanel-children">
              {isOpen && this.props.children}
            </div>
          </div>
        </div>
        <div className={menu} id="overlay" />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/common/slidingPanel/index.js